import { Link } from '@tanstack/react-router';

/**
 * Workspace unresolved page.
 *
 * Shown when `requireWorkspace` finds the current host does not resolve to a
 * known workspace. Deliberately NOT routed to `/denied` — that would tell a
 * legitimate operator their permissions are wrong when the truth is the address
 * is not recognised.
 */
export function WorkspaceUnresolvedPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-surface px-4">
      <div className="max-w-md space-y-4">
        <h1 className="text-2xl font-bold text-content">Workspace not recognised</h1>
        <p className="text-content-muted">
          This address does not resolve to a known Mana Locals workspace.
        </p>
        <p className="text-sm text-content-muted/60">
          Contact your administrator to register this host, or sign in again from
          a recognised address.
        </p>
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-accent underline-offset-4 hover:underline"
        >
          <span>Sign in</span>
        </Link>
      </div>
    </main>
  );
}
